<template>
  <div class="teas-modify-password-div">
    <div class="teas-modify-password-page" v-if="!step">
      <div class="page-title">{{title || ""}}</div>
      <div class="page-notice">{{notice || ""}}</div>
      <van-field
        class="input-content-item"
        v-model="newPwd"
        type="password"
        clearable="true"
        placeholder="请输入新密码"
      />
      <div class="error-content" v-if="alterResult.length > 0">
        <span class="iconfont icon-tixingshixin"></span>
        {{alterResult || ""}}
      </div>
      <van-field
        class="input-content-item"
        v-model="confirmPwd"
        type="password"
        clearable="true"
        placeholder="请再次输入新密码"
      />
      <van-button
        class="teas-modify-password-btn"
        :class="!(newPwd && newPwd === confirmPwd) ? 'disabled' : ''"
        :disabled="!(newPwd && newPwd === confirmPwd)"
        @click="nextStep"
      >
        确定
      </van-button>
    </div>
    <div class="teas-modify-password-page" v-if="step">
      <div class="success-img-content">
        <img class="success-img" :src="successImg" alt="">
      </div>
      <div class="success-notice">密码修改成功</div>
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfMobileTeasModifyPassword",
  ctrlCaption: "修改密码",
  mixins: [$mixins.control],
  props: {
    title: {
      type: String,
      default: "修改密码",
    },
    alterUrl: {
      type: String,
      default: "user/password/checkStrengthPwd",
    },
    authUrl: {
      type: String,
      default: "user/password/updatePwd",
    },
    intervalUrl: {
      type: String,
      default: "user/password/getUpdatePwdRule",
    },
  },
  data() {
    return {
      notice: "",
      // 是否修改成功
      step: false,
      // 新密码
      newPwd: "",
      // 确认 新密码
      confirmPwd: "",
      // 返回错误结果
      alterResult: "",
      successImg:require('_teas/public/img/product/modify-password-success.jpg'),
    };
  },
  mounted() {
    this.$http
      .get(this.intervalUrl, {})
      .done(({ success, data }) => {
        if (success) {
          this.notice = data.notice;
        }
      })
      .error((err) => {
        dsf.error(err);
      })
      .always(() => {});
  },
  methods: {
    nextStep() {
      this.$http
        .get(this.alterUrl, { param: this.newPwd })
        .done(({ success, message }) => {
          if (success) {
            this.alterPwd();
          } else {
            this.alterResult = message;
          }
        })
        .error((err) => {
          dsf.error(err);
          dsf.layer.message(err?.message || "请求异常", false);
        });
    },
    alterPwd() {
      const loading = dsf.layer.loading();
      let _this = this;
      this.$http
        .post(this.authUrl, { param: dsf.md5(dsf.md5(this.newPwd)) })
        .done(({ success, message }) => {
          dsf.layer.closeLoading(loading);
          if (success) {
            if (_this.queryString.reset_pwd == 1) {
              dsf.layer.message('修改成功', true);
              setTimeout(function() {
                 location.replace(dsf.config.setting_public_mobile_login_page)
              }, 1000)
            }else {
              _this.step = true;
            }
            
          } else {
            dsf.layer.message(message || "请求失败", false);
          }
        })
        .error((err) => {
          dsf.layer.closeLoading(loading);
          dsf.layer.message(err?.message || "请求异常", false);
        })
        .always(() => {});
    },
  },
});
</script>
